import camundaModdle from 'camunda-bpmn-moddle/resources/camunda.json';

export const commonModules = [];

/**
 * @type { {
 *   camunda: any
 * } }
 */
export const commonModdleExtensions = {
  camunda: camundaModdle
};